export default __webpack_public_path__ + "static/media/12.08fb394f.png";